import ActionType from '../ActionType'

export const toggleDialog = (payload) => (dispatch) =>
  dispatch({ type: ActionType.Users.TOGGLE_DIALOG, payload })

export const toggleState = (payload) => (dispatch) =>
  dispatch({ type: ActionType.Users.TOGGLE_STATE, payload })

export const selectUser = (payload) => (dispatch) =>
  dispatch({ type: ActionType.Users.SELECT_USER, payload })
